const baseURL = "/v1/AcompanhamentoDeTurma";

const service = {
  methods: {
    $buscar(params) {
      return this.$api().get(`${baseURL}`, params );
    },
    $visualizar(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $visualizarAdministracao(id) {
      return this.$api().get(`${baseURL}/Administracao/${id}`);
    },
    $cadastrar(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editar(body) {
      return this.$api().put(`${baseURL}/Editar`, body);
    },
    $listarPraticasUnidades(params) {
      return this.$api().get(`${baseURL}/ListarPraticasUnidades`, { params });
    },
  },
};

export default service;
